//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import analyticEvents from '~/services/analyticEvents';
import { slugify } from '~/services/utilityFunctions.js';
export default {
    name: 'TableOfContentList',
    props: {
        listItems: {
            type: Array,
            default: () => {
                return [];
            }
        },
        activeTopic: {
            type: String,
            default: ''
        },
        currentActiveSection: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            selectedTopic: this.activeTopic
        };
    },
    watch: {
        currentActiveSection(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.selectedTopic = this.currentActiveSection;
            }
        }
    },
    methods: {
        scrollToSelectedSection(item) {
            this.selectedTopic = item;
            this.$emit('setSelectedTopic', item);
            // Do More with Section ID;s
            const slug = '#' + slugify(item);
            this.$router.push(slug);
            this.$store.dispatch('analytics/trackEvent', {
                event: analyticEvents.table_of_content_clicked,
                data: {
                    blog_url: `${window.location.origin}${this.$route.path}${slug}`
                }
            });
        },
        slugify
    }
};
